import { loadView } from '@/router'

export default [
  {
    path: 'generate',
    name: 'billing-generate',
    component: loadView('Application/Billing/GenerateInvoices'),
    showInAlfred: true,
    alfredTitle: 'Billing - Generate Invoices'
  }
]
